import { FC, useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { IFieldInput } from "./fieldInput.type";
import { validateFields } from "src/utils";
import { InlineIcon } from "@iconify/react";

import "./style.css"

const FieldInput: FC<IFieldInput> = ({ name, label, value, setValue, type = "text", className = "", placeholder, requiredMessage, errorMessage, isRequired = false, disabled = false, defaultValue }) => {

    const [showPassword, setShowPassword] = useState<boolean>(false)
    const { t } = useTranslation()

    const handleChange = (e: any) => {
        setValue({
            value: e.target.value,
            errorMsg: errorMessage ?? "",
            isRequired: isRequired
        });
        validateFields({ setter: setValue, name, value: e.target.value, isRequired, requiredMessage });
    };

    useEffect(() => {
        setValue({ value: defaultValue ? defaultValue : "", errorMsg: "", isRequired: isRequired })
    }, [defaultValue])

    const uniqueId = useMemo(() => `${name}-${label}-${Math.random().toString(36).substring(2)}`, [name, label]);

    return (
        <div className={`form-fields ${className}`} >
            <label className="label-input" htmlFor={uniqueId}>
                {t(label)}
            </label>
            <input
                id={uniqueId}
                name={name}
                type={showPassword ? "text" : type}
                value={value.value || ''}
                placeholder={placeholder ? t(placeholder) ?? '' : `${t('Enter Your')} ${t(name)}`}
                onChange={handleChange}
                disabled={disabled}
                className={`form-control ${value.errorMsg ? 'is-invalid' : ''}`}
            />

            {value.errorMsg && (<div className="invalid-feedback" style={{ display: 'block' }}>{t(value.errorMsg)}</div>)}

            {type === "password" && (
                <InlineIcon className="field-icon" icon={`clarity:eye-${showPassword ? "show" : "hide"}-line`} onClick={() => setShowPassword((prev) => !prev)} />
            )}
        </div >
    )
}

export default FieldInput
